import { PaginationRequestModel } from "@/models";
import { TaskFilterModel } from "./TaskFilterModel";
import { TaskSortingModel } from "./TaskSortingModel";

export class GetProjectTasksRequestModel {
  CurrentUserId!: number;
  /**ID проекта */
  ProjectId!: number;
  /**Фильтр */
  Filter!: TaskFilterModel;
  /**Пагинация */
  Page?: PaginationRequestModel;
  DateStart?: Date;
  DateEnd?: Date;
  /**Сортировка */
  Sort: TaskSortingModel = new TaskSortingModel();
  IsFilterTimerByPerformerIds: boolean = false;

  constructor(obj?: Partial<GetProjectTasksRequestModel>) {
    Object.assign(this, obj);
  }
}
